import React, { useState } from 'react';
import { SwatchIcon } from '@heroicons/react/24/outline';
import CustomColorModal from '../modals/CustomColorModal';

const PAPER_COLORS = [
  { name: 'White', value: '#8585FF' },
  { name: 'Cream', value: '#C58B4E' },
  { name: 'Light Gray', value: '#6B7280' },
  { name: 'Pale Yellow', value: '#EAB308' },
  { name: 'Soft Blue', value: '#3B82F6' },
  { name: 'Mint', value: '#10B981' },
  { name: 'Custom RGB', value: 'custom' },
];

export default function CoverPaperColorPicker({ currentColor, onChange }) {
  const [isCustomColorModalOpen, setIsCustomColorModalOpen] = useState(false);

  const handleColorClick = (color) => {
    if (color.value === 'custom') {
      setIsCustomColorModalOpen(true);
    } else {
      onChange(color.value);
    }
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow-sm border border-gray-200">
          <SwatchIcon className="h-5 w-5 text-gray-600" />
          <span className="text-sm font-medium text-gray-700">Cover Page</span>
        </div>
        <div className="flex gap-2">
          {PAPER_COLORS.map((color) => {
            const isCustom = color.value === 'custom';
            const isSelected =
              currentColor === color.value ||
              (isCustom && !PAPER_COLORS.find((c) => c.value === currentColor));

            return (
              <button
                key={color.value}
                onClick={() => handleColorClick(color)}
                className={`w-8 h-8 rounded-full border-2 ${
                  isSelected
                    ? 'border-indigo-500 ring-2 ring-indigo-200'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
                style={{
                  background: isCustom
                    ? 'linear-gradient(45deg, #FF0000, #00FF00, #0000FF)'
                    : color.value,
                  boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)',
                }}
                title={color.name}
              >
                {isCustom && <span className="sr-only">Custom Color</span>}
              </button>
            );
          })}
        </div>
      </div>

      <CustomColorModal
        isOpen={isCustomColorModalOpen}
        onClose={() => setIsCustomColorModalOpen(false)}
        initialColor={currentColor}
        onColorSelect={onChange}
      />
    </>
  );
}
